import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import MembGameLoginApi from 'Apis/MembGameLoginApi';
import { useState ,useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate ,useLocation, Link} from "react-router-dom";
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import GameSsoLoginUi from './GameSsoLoginUi';
import MembJoinLink from './MembJoinLink';
import IsLoginApi from 'Apis/IsLoginApi';
import { useSelector } from 'react-redux';

import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
import MgpStore from "Stores/Store";
import { useDispatch} from 'react-redux';
import useRecaptcha from 'Utils/useRecaptcha';
import AthnQrLoginUrlApi from 'Apis/AthnQrLoginUrlApi';
import AthnQrLoginSseApi from 'Apis/AthnQrLoginSseApi';
import AthnQrLoginCmplApi from 'Apis/AthnQrLoginCmplApi';
import { QRCodeCanvas } from 'qrcode.react';
import { Check, LoaderCircle, RefreshCw, X } from 'lucide-react';


declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}
const GameLogin = () => {
    const { push: gtmPush } = useGtm();
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let osKindCd = query.get("osKindCd");
    let redirectUri = query.get("redirectUri");

    const dispatch = useDispatch();
    const [loginId,setLoginId] = useState("");
    const [passwd,setPasswd] = useState("");
    const [loginAlertTxt,setloginAlertTxt] = useState("");
    const [qrLoginUrl, setQrLoginUrl] = useState("");
    const [validSec, setValidSec] = useState(0);
    const [isQrRefreshing, setIsQrRefreshing] = useState(false);
    const [qrLoginStatus, setQrLoginStatus] = useState("ISSU");
    const [isAppDownloadOpen, setIsAppDownloadOpen] = useState(false);
    const qrLoginEventSourceRef = useRef<EventSource | null>(null);
    
    // 자동로그인 체크박스 상태
    const [mltSetYn, setMltSetYn] = useState("N");
    const mltSetYnRef = useRef(mltSetYn);
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    
    const LoginIdHandler = (event:any) => {
        setLoginId(event.currentTarget.value);
        setloginAlertTxt("");
    }
    const PasswdHandler = (event:any) => {
        setPasswd(event.currentTarget.value);
        setloginAlertTxt("");
    }
    const membJoinLinkTxt = [langData&&langData.LOGIN_FIND_LOGIN_ID_BTN_00,langData&&langData.LOGIN_FIND_PASSWD_MAIN_BTN_00,langData&&langData.LOGIN_MEMB_JOIN_MAIN_BTN_00];
    const { getToken } = useRecaptcha();
    const navigate = useNavigate();
    const loginInfoState = useSelector((state: any) => state.LoginInfoState?.LoginInfo?.apiBody);

    useEffect(() => {
        mltSetYnRef.current = mltSetYn;
    }, [mltSetYn]);

    const requestQrLogin = useCallback(async () => {
        setIsQrRefreshing(true);
        try {
            const data = await AthnQrLoginUrlApi();
            if(data?.apiBody?.qrLoginUrl) {
                setQrLoginStatus("ISSU");
                setValidSec(Math.max(Number(data.apiBody.validSec) || 0, 0));
                setQrLoginUrl(data.apiBody.qrLoginUrl);
                qrLoginEventSourceRef.current?.close();
                qrLoginEventSourceRef.current = AthnQrLoginSseApi(
                    async (eventType, sseData) => {
                        console.log(`게임 QR 로그인 SSE ${eventType}`, sseData);

                        if(eventType === "message") return;
                        setQrLoginStatus(eventType);

                        if(eventType === "EXPR") {
                            setValidSec(0);
                            return;
                        }

                        if(eventType === "RJCT") {
                            qrLoginEventSourceRef.current?.close();
                            qrLoginEventSourceRef.current = null;
                            setValidSec(0);
                            return;
                        }

                        if(eventType === "APRV") {
                            const approvedAt = Date.now();
                            qrLoginEventSourceRef.current?.close();
                            qrLoginEventSourceRef.current = null;
                            const completionData = await AthnQrLoginCmplApi();

                            if(completionData?.apiHdr?.code === "ATHN0000") {
                                const remainingDelay = Math.max(1000 - (Date.now() - approvedAt), 0);
                                await new Promise((resolve) => window.setTimeout(resolve, remainingDelay));
                                navigate(`/gameLnchStrt?gameSvcCd=${encodeURIComponent(getGameSvcCd || "")}&mltSetYn=${encodeURIComponent(mltSetYnRef.current)}`, { replace: true });
                            } else {
                                setQrLoginStatus("EXPR");
                                setValidSec(0);
                                setloginAlertTxt(completionData?.apiHdr?.msg || "QR 로그인에 실패했습니다.");
                            }
                        }
                    },
                    (readyState) => {
                        if(readyState === EventSource.CLOSED) {
                            console.error("게임 QR 로그인 SSE 연결이 종료되었습니다.");
                        }
                    },
                    () => console.info("게임 QR 로그인 SSE 연결 완료"),
                );
            }
        } finally {
            setIsQrRefreshing(false);
        }
    }, [getGameSvcCd, navigate]);

    useEffect(() => {
        if(loginInfoState?.login === true) return;
        requestQrLogin();

        return () => {
            qrLoginEventSourceRef.current?.close();
            qrLoginEventSourceRef.current = null;
        };
    }, [loginInfoState?.login, requestQrLogin]);

    useEffect(() => {
        if(!qrLoginUrl) return;
        if(validSec <= 0) {
            qrLoginEventSourceRef.current?.close();
            qrLoginEventSourceRef.current = null;
            return;
        }

        const timer = window.setTimeout(() => {
            setValidSec((seconds) => Math.max(seconds - 1, 0));
        }, 1000);

        return () => window.clearTimeout(timer);
    }, [qrLoginUrl, validSec]);

    // 로그인 상태가 true면 바로 리다이렉트
    if (loginInfoState && loginInfoState.login === true) {
        navigate("/gameLnchStrt", { state: { gameSvcCd: getGameSvcCd }, replace: true });
        return null;
    }
    const AutoLoginHandler = (event:any) => {
        setMltSetYn(event.target.checked ? "Y" : "N");
    }
    const MembLoginFunc = async (e:any) => {
        e.preventDefault();
        if(!loginId) {
            setloginAlertTxt(langData&&langData.MEMB_JOIN_ID_INPUT_DESC_00);
            //아이디를 입력해주세요.
        }else if(!passwd){
            setloginAlertTxt(langData&&langData.MEMB_JOIN_PASSWD_INPUT_DESC_00)
            // 비밀번호를 입력해주세요.
        }else {
            try {
                const token = await getToken('login');
                const Resp = await MembGameLoginApi(getGameSvcCd, loginId, passwd, token, redirectUri, mltSetYn);
                switch(Resp.data.apiHdr.code){
                    case "GAME0000":
                         if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                    }
                    const tsKst = getKstTimestamp();
                    const adPayload = await fetchAdPayload( getGameSvcCd||'BBO');
                    try {

                        gtmPush('BBO_GA_Login_Complete', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Login_Complete',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                       navigate(`/gameLnchStrt?gameSvcCd=${encodeURIComponent(getGameSvcCd || "")}&mltSetYn=${encodeURIComponent(mltSetYn)}`,{replace:true});
                        break;
                    case "ATHN2000":
                        setloginAlertTxt(langData&&langData.LOGIN_MAIN_RSLT_DESC_00);
                    break;
                    case"ATHN2002":
                        navigate("/BlckMemb",{state:{loginId:loginId},replace:true});
                    break;
                    case"ATHN2005":
                        navigate("/membLvdCncl",{state:{loginId:loginId},replace:true});
                    break; 
                    case "ATHN2007": {
                        // 현재 리퍼러 파라미터를 OTP 페이지로 넘김
                        const launchReferrer = `/gameLnchStrt?gameSvcCd=${encodeURIComponent(getGameSvcCd || "")}&mltSetYn=${encodeURIComponent(mltSetYn)}`;
                        navigate(`/OtpAthn?referrer=${encodeURIComponent(launchReferrer)}`);
                    }
                    break;
                    case"ATHN2003":
                        navigate("/DrmcMemb",{state:{loginId:loginId},replace:true});
                    break;        
                    case"ATHN2309":
                        setloginAlertTxt(langData&&langData.LOGIN_MAIN_RSLT_DESC_00);
                    break;
                    case"ATHN2313":
                        setloginAlertTxt("로그인 시도 횟수가 많습니다. 잠시 후 다시 시도해주세요.");
                    break;
                    default:
                        setloginAlertTxt(`${Resp.data.apiHdr.msg} `);
                    break;
                    
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('reCAPTCHA token failed', e);
            }
        }
    }

    const isQrScanning = qrLoginStatus === "SCAN";
    const isQrApproved = qrLoginStatus === "APRV";
    const isNonProductionHost = /(^localhost$|^127\.0\.0\.1$|-dev\.|-alpha\.|-beta\.)/i.test(window.location.hostname);
    const appDownloadUrl = isNonProductionHost
        ? "https://app-dev.bearbrickconnect.com/go/home"
        : "https://app.bearbrickconnect.com/go/home";
    const qrStatusText = qrLoginStatus === "RJCT"
        ? "앱에서 로그인을 취소했습니다"
        : validSec <= 0
            ? "QR 코드가 만료되었습니다."
            : null;


    return(
        <>
        <div className='loginInputWrap qrLoginPage'>
            <Helmet>
                <title>{`${process.env.REACT_APP_TITLE_PREFIX} GameLogin`}</title>
            </Helmet>
            <div className="qrLoginFormColumn">
            <form action="" onSubmit={MembLoginFunc}>
                <ul className='loginInputUl'>
                    <li>
                        <input placeholder={`${langData&&langData.LOGIN_MAIN_LOGIN_ID_LBL_00}`} className='idInput' onChange={LoginIdHandler}></input>
                        {/* 아이디 */}
                    </li>
                    <li>
                        <input placeholder={`${langData&&langData.LOGIN_MAIN_PASSWD_MAIN_LBL_00}`} type='password' className='passwdInput' autoComplete="off" onChange={PasswdHandler}></input>
                        {/* 비밀번호 */}
                    </li>
                    
                    <p className='loginAlertTxt'>{loginAlertTxt}</p>
                </ul>
                <div className='agreLi' style={{maxWidth:"390px",margin:"0 auto",marginTop:"45px"}}>
                    <input type="checkbox" id="autoLogin" value={mltSetYn} checked={mltSetYn === "Y"} onChange={AutoLoginHandler} />
                    <label htmlFor="autoLogin">
                            {langData&&langData.GLB_AUTO_LOGIN_CHK_00}
                    </label>
                </div>
                <button className='loginBtn gameLoginBtn' type='submit'>{langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}</button>
                {/* 로그인 */}
            </form>
            <GameSsoLoginUi viewType='page' gameSvcCd={getGameSvcCd} mltSetYn={mltSetYn} />
            <MembJoinLink membJoinLinkTxt={membJoinLinkTxt}/>
            <div className="capthCpyr">
                {/* reCAPTCHA provided at app root; tokens requested via useRecaptcha hook */}
                <p>
                    This site is protected by reCAPTCHA and the Google
                    <br />
                    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                    <a href="https://policies.google.com/terms"  target="_blank">Terms of Service</a> apply.
                </p>
            </div>
            </div>
            {qrLoginUrl && (
                <div className="qrLoginPanel">
                    <div className="qrLoginCodeWrap">
                        <h2>또는 QR 코드로 로그인</h2>
                        <div className="qrLoginImageFrame">
                            <div className={`qrLoginImage${validSec <= 0 || isQrScanning || isQrApproved ? " isBlurred" : ""}${isAppDownloadOpen ? " isHidden" : ""}`}>
                                <div className="qrLoginCanvas">
                                    <QRCodeCanvas value={qrLoginUrl} size={180} />
                                </div>
                            </div>
                            {isQrScanning && (
                                <div className="qrLoginLoadingOverlay" role="status" aria-label="QR 로그인 승인 대기 중">
                                    <span className="qrLoginLoadingBadge">
                                        <LoaderCircle className="qrLoginLoadingIcon" size={40} aria-hidden="true" />
                                    </span>
                                </div>
                            )}
                            {isQrApproved && (
                                <div className="qrLoginLoadingOverlay qrLoginApprovedOverlay" role="status" aria-label="로그인 승인 완료">
                                    <Check size={44} strokeWidth={3} aria-hidden="true" />
                                </div>
                            )}
                            {validSec <= 0 && !isQrApproved && (
                                <button
                                    type="button"
                                    onClick={requestQrLogin}
                                    disabled={isQrRefreshing}
                                    aria-label={isQrRefreshing ? "QR 새로고침 중" : "QR 새로고침"}
                                    title={isQrRefreshing ? "새로고침 중" : "QR 새로고침"}
                                    className="qrLoginRefreshButton"
                                >
                                    <span>
                                        <RefreshCw size={24} aria-hidden="true" />
                                    </span>
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="qrLoginStatus">
                        {qrStatusText && <p aria-live="polite">{qrStatusText}</p>}
                    </div>
                    <p className="qrLoginGuide">
                        <button type="button" onClick={() => setIsAppDownloadOpen(true)}>CONNECT 앱</button>을 사용하여<br />
                        QR 코드로 로그인
                    </p>
                </div>
            )}
            {isAppDownloadOpen && createPortal(
                <div className="qrAppDownloadOverlay" onClick={() => setIsAppDownloadOpen(false)}>
                    <section
                        className="qrAppDownloadModal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="gameQrAppDownloadTitle"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <button
                            type="button"
                            className="qrAppDownloadClose"
                            onClick={() => setIsAppDownloadOpen(false)}
                            aria-label="CONNECT 앱 받기 닫기"
                        >
                            <X size={22} aria-hidden="true" />
                        </button>
                        <h2 id="gameQrAppDownloadTitle">CONNECT 앱 받기</h2>
                        <div className="qrAppDownloadCode">
                            <QRCodeCanvas value={appDownloadUrl} size={132} />
                        </div>
                        <p>휴대폰 카메라로 스캔하면<br />설치 페이지로 이동합니다</p>
                        <div className="qrAppStoreLinks">
                            <a href="https://apps.apple.com/kr/app/bearbrick-connect/id6777928150" target="_blank" rel="noopener noreferrer">App Store</a>
                            <a href="https://play.google.com/store/apps/details?id=com.bearbrick.connect" target="_blank" rel="noopener noreferrer">Google Play</a>
                        </div>
                        <small>휴대폰 카메라로 로그인 QR을 찍어도<br />CONNECT 앱으로 바로 이어집니다</small>
                    </section>
                </div>,
                document.body,
            )}
        </div>
        </>
    )
}

export default GameLogin;